import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import {
  DashboardQuery,
  DashboardGraphReceitaDespesaResultado,
} from "../typings";

export function useReceitaDespesaResultado(params: DashboardQuery) {
  return useQuery<DashboardGraphReceitaDespesaResultado, AxiosError>(
    `/v1/dashboards/principal/grafico-receita-despesa-resultado-${params.dataFim}-${params.dataInicio}-${params.updatedAt}`,
    async () => {
      const { data } = await http.get<DashboardGraphReceitaDespesaResultado>(
        "/v1/dashboards/principal/grafico-receita-despesa-resultado",
        {
          params,
        }
      );

      return data;
    }
  );
}
